import React from "react";
import { FormattedMessage } from "react-intl";
import { Space } from "@masterteam/mt-design-react";
import Breadcrumb from "../../Breadcrumb";

const Header = () => {
  const breadcrumb = [
    <FormattedMessage id="common.initiatives" />,
    <FormattedMessage id="common.initiative-details" />,
  ];

  return (
    <Space
      direction="vertical"
      size="large"
      className="initiative-details-container__header"
    >
      <Breadcrumb data={breadcrumb} fontSize="var(--font-large)" />
    </Space>
  );
};

export default Header;
